import { useState, useEffect } from 'react';
import { PublicTenantControllerService } from '../api/services/PublicTenantControllerService';
import { type TenantDto } from '../api/models/TenantDto';
import { type Tenant } from '../config/environment';

export function useTenants() {
    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchTenants = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await PublicTenantControllerService.getAvailableTenants();
                
                // Transform TenantDto to Tenant interface
                const transformedTenants: Tenant[] = response
                    .filter((tenant: TenantDto) => tenant.id && tenant.name)
                    .map((tenant: TenantDto) => ({
                        uuid: tenant.id!,
                        name: tenant.name!
                    }));
                
                setTenants(transformedTenants);
            } catch (err: any) {
                console.error('Failed to fetch tenants:', err);
                // On login page: 401 (e.g. expired token in header) should not block – show no error so login form is usable
                if (typeof window !== 'undefined' && window.location.pathname === '/login' && (err?.status === 401 || err?.response?.status === 401)) {
                    setError(null);
                } else {
                    setError(err.message || 'Failed to fetch tenants');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchTenants();
    }, []);

    return { tenants, loading, error };
} 